import React from 'react'
import _ from 'lodash'
import pluralize from 'pluralize'
import '../assets/css/components/expandable-overview.css'
import BasicBar from './BasicBar'
import HintButton from './HintButton'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle, faSlidersH } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faInfoCircle, faSlidersH)

class ExpandableOverview extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isExpanded: false }
  }

  expansionClasses = ()=> {
    const expandedClass = this.state.isExpanded ? 'expanded' : ''
    const fullSizeClass = this.props.isFullSize ? 'full-size' : ''
    return [expandedClass, fullSizeClass].join(' ')
  }

  handleToggleExpansion = ()=>
    this.setState({ isExpanded: !this.state.isExpanded })

  hiddenItemCount = ()=>
    this.state.isExpanded ? 0 : (this.getExpandableContent().length - this.props.previewSize)

  getPreviewText = ()=> {
    const { previewText } = this.props
    if(this.state.isExpanded || _.isEmpty(previewText)){ return }

    let parsedPreviewText = previewText.replace('%%', this.hiddenItemCount())

    return _.map(parsedPreviewText.split(' '), word => {
        if(word.charAt(0) === '$' && word.charAt(1) === '$') {
          return pluralize(word.replace('$$',''), this.hiddenItemCount())
        } else {
          return word
        }
      }
    ).join(' ') + '.'
  }

  getToggleText = ()=>
    this.state.isExpanded ? '< View Less' : 'View All >'

  showToggle = ()=>{
    const { previewText, previewSize } = this.props
    const hasPreviewSizeOrText = !_.isEmpty(previewSize) || !_.isEmpty(previewText)
    const hasMoreContentThanPreviewSize = !(previewSize >= this.getExpandableContent().length)

    return this.state.isExpanded || (hasMoreContentThanPreviewSize && hasPreviewSizeOrText)
  }

  getPersistentContent = ()=> {
    const { children } = this.props
    const childList = _.isArray(children) ? children : [children]
    return _.find(childList, child => (child.props.className || '').includes('persistent-content'))
  }

  getFooterContent = ()=> {
    const { children } = this.props
    const childList = _.isArray(children) ? children : [children]
    return _.find(childList, child => (child.props.className || '').includes('footer-content'))
  }

  getExpandableContent = ()=> {
    const { children } = this.props
    const childList = _.isArray(children) ? children : [children]
    const expandableWrapper = _.find(childList, child => (child.props.className || '').includes('expandable-content'))
    // Clone each child and inject the isExpanded prop into them
    // TODO: there are issues with how this function handles children.
    // If you structure child elements in the following way, React breaks in very ambiguous ways that I have yet to track down:
    // <div className='child-container'>
    //  {conditionOne && <h1>hi</h1>}
    //  {!conditionOne && <h1>bye</h1>}
    // </div>
    if(_.isEmpty(expandableWrapper)) {
      return []
    } else {
      const wrapperChildren = _.filter(_.isArray(expandableWrapper.props.children) ? expandableWrapper.props.children : [expandableWrapper.props.children], child => _.isObject(child)).flat()
      const asdf = _.compact(_.map(wrapperChildren, child => _.isObject(child) ? React.cloneElement(child, { isContainerExpanded: this.state.isExpanded }) : undefined ))
      return asdf
    }
  }

  getVisibleContent = ()=>{
    const { isLoading, previewSize } = this.props
    if(isLoading) {
      return _.map(new Array(previewSize), (i,index) => {
      return (<BasicBar key={'Basic-bar-'+index}/>)
      })
    } else {
      const contentToDisplay = this.state.isExpanded ? this.getExpandableContent() : this.getExpandableContent().slice(0, previewSize)
      if(contentToDisplay.length === 0) {
        return <div className='empty-message'>No Content</div>
      } else {
        return contentToDisplay
      }
    }
  }

  render() {
    const { title, hint } = this.props
    return(
      <div className={`expandable-overview-wrapper ${this.expansionClasses()}`}>
        <div className='expandable-overview'>
          <h2>
            <span className='text-uppercase'>{title}</span>
            {hint && <HintButton hint={hint}/>}
          </h2>

          {this.getPersistentContent()}
          <div className='children-container'>
            {this.getVisibleContent()}
          </div>
          {this.getFooterContent()}

          {this.showToggle() && [
            <div className='divider'></div>,
            <div className='expand-text'>
              <span className='preview-text'>{this.getPreviewText()}</span>
              <span onClick={this.handleToggleExpansion} className='view-link text-uppercase'>
                {this.getToggleText()}
              </span>
            </div>
          ]}
        </div>
      </div>
    );
  }
}

ExpandableOverview.defaultProps = {
  isFullSize: false
}

export default ExpandableOverview;
